import { useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';

import { usePrev } from '@libs/hooks/usePrev';

import { TournamentAdditionalScore } from '@features/shared/api/typings';
import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings';
import { ScoreOption } from '@features/tournament/ui/components/TournamentSettings/inputs/AdditonalScoreInput';

export function useDeduplicateScoreOptions(
  options: ScoreOption[],
  setValue: UseFormSetValue<TournamentEditFormValues>,
  fieldName: string,
  values?: TournamentAdditionalScore[] | null,
) {
  const prevValues = usePrev(values);

  useEffect(() => {
    if (!values) return;

    const existingValues: { [k: string]: number } = {};
    const valuesLeft = new Set(options.filter((o) => !!o.value && !o.disabled).map((o) => o.value));
    let changedIdx = -1;
    let duplicateIdx = -1;

    values.forEach((v: TournamentAdditionalScore, k: number) => {
      valuesLeft.delete(v);
      if (v !== prevValues?.[k]) {
        changedIdx = k;
      }
      if (v in existingValues && !!v) {
        duplicateIdx = changedIdx === k ? existingValues[v]! : k;
      }
      existingValues[v] = k;
    });

    if (changedIdx === -1 || duplicateIdx === -1) return;

    setValue(
      (fieldName + '.' + duplicateIdx) as 'additionalScoreOrder.0',
      [...valuesLeft][0] as TournamentAdditionalScore,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);
}
